<template>
<v-dialog
    v-model="dialog"
    max-width="920"
    v-if="summary != null"
>
    <v-card>
        <v-card-title>
            {{title}}
            <v-chip
                v-if="is_in_beta"
                color="orange"
                text-color="white"
                small
                class="ml-2"
            >
                BETA
            </v-chip>
        </v-card-title>

        <v-card-text
            v-if="summary != null"
            style="margin-top: 15px;"
        >
            <integration-api-docs
                :integration_type="summary.content_type"
                :organization_id="summary.organization_id"
            />
            <!--Can't live in the integration-api-docs component because our secrets page references tock v2 as 'tock' :(-->
            <div
                v-if="is_tock_v1"
            >
                <b>To connect tock and RedChirp:</b>
                <ul>
                    <li>Sign into <a href="https://dashboard.exploretock.com/" target="_blank">https://dashboard.exploretock.com</a></li>
                    <li>Go to Control Panel</li>
                    <li>In the left pane, select Settings (it is under Business)</li>
                    <li>On the Settings pane, select notifications (it is on the left, under the general section, second from the bottom)</li>
                    <li>Add the (below) email address to the Reservation notifications Email Addresses (separate multiple email addresses with a comma -- ,)</li>
                </ul>
            </div>
            
            <v-text-field
                label="Internal Label"
                hint="If set, a custom label for this integration used (only) inside of RedChirp. Especially important to differentiate multiple integrations of the same type."
                persistent-hint
                v-model="summary.integration_label"
                autocomplete="off"
            />

            <v-text-field
                label="Brand Label"
                hint="If set, then automated messages trigged by this integration will use this value as {brand-label}"
                persistent-hint
                v-model="summary.brand_label"
                autocomplete="off"
            />

            <v-text-field
                label="Tenant"
                hint="Log into Commerce7.  Look at the host name in the URL.  The tenant is the word before the first . of the hostname."
                v-model="summary.tenant"
                v-if="is_commerce7"
                autocomplete="off"
            />

            <v-text-field
                label="VinesOS Domain"
                hint="The domain for your VinesOS hosted site, e.g. redchirp.vinesos.com or www.redchirp.com"
                v-model="summary.tenant"
                v-if="is_vineos"
                autocomplete="off"
            />

            <v-text-field
                label="Tenant"
                hint="Your shipper code from WineCo"
                v-model="summary.tenant"
                v-if="is_wineco"
                autocomplete="off"
            />

            <v-text-field
                label="Account Number"
                hint="Your WineDirect Fulfillment account number (typically an 8 digit number)"
                v-model="summary.tenant"
                v-if="is_wine_direct_fulfillment"
                autocomplete="off"
            />


            <v-text-field
                label="Mailchimp datacenter"
                hint="Log into Mailchimp.  Look at the host name in the URL.  The datacenter is the word before the first . of the hostname.  For example, if your url is https://us5.admin.mailchimp.com/ then the datacenter is us5"
                v-model="summary.tenant"
                v-if="is_mailchimp"
                autocomplete="off"
            />

            <v-text-field
                label="Shopify Domain"
                hint="The domain for your Shopify store, e.g. www.redchirp.com or redchirp.myshopify.com"
                v-model="summary.tenant"
                v-if="is_shopify"
                autocomplete="off"
            />
            <div
                v-if="is_shopify"
                class="mb-4"
            >
                <a @click="showShopifyInstructions">How to reconnect Shopify to RedChirp</a>
            </div>

            <div
                v-if="is_wine_shipping"
                class="mt-4 mb-4"
            >
                <p><b>How to connect Wineshipping to RedChirp</b></p>
                <ul>
                    <li>Contact Wineshipping support</li>
                    <li>Tell them that you would like to connect your Wineshipping account to RedChirp</li>
                    <li>
                        Tell them that your RedChirp webhook url is:

                        <m-edit-text
                            label="Wineshipping webhook url"
                            read_only
                            :value="'https://app.redchirp.com/api/v1/webhook/inbound/wine-shipping/shipping-events/'+summary.organization_id"
                        >
                        </m-edit-text>
                    </li>
                </ul>
            </div>

            <v-text-field
                label="Business Group Id"
                v-model="summary.tenant"
                v-if="is_tock_v2"
                autocomplete="off"
            />


            <v-select
                label="Agency (Tenant)"
                hint="This can only be set by a RedChirp Administrator"
                v-model="summary.tenant"
                v-if="is_clear_care"
                :items="clear_care_tenant_choices"
            />

            <v-text-field
                label="Client Id"
                v-model="summary.tenant"
                v-if="is_order_port"
                autocomplete="off"
            />

            <v-text-field
                label="Business Id"
                v-model="summary.username"
                v-if="is_tock_v2"
                autocomplete="off"
            />

            <v-text-field
                label="Username"
                hint="Your vinSUITE username"
                v-model="summary.username"
                v-if="is_vinsuite"
                autocomplete="off"
            />

             <v-text-field
                label="Username"
                hint="Your WineDirect username (must be a WebService account)"
                v-model="summary.username"
                v-if="is_winedirect"
                autocomplete="off"
            />

            <v-text-field
                label="Username"
                hint="Your WineDirect Fulfillment Username "
                v-model="summary.username"
                v-if="is_wine_direct_fulfillment"
                autocomplete="off"
            />

            <v-text-field
                label="Username"
                hint="Your eCELLAR API username"
                v-model="summary.username"
                v-if="is_ecellar"
                autocomplete="off"
            />

            <v-text-field
                label="Username"
                hint="Your web services username"
                v-model="summary.username"
                v-if="is_ship_compliant"
                autocomplete="off"
            />



            <v-text-field
                label="Store Hash"
                hint="Your All New WineDirect (ANDW) store hash (eCommerce > Settings > URL will read https://store-[store-hash].mybigcommerce.com/manage/settings-list)"
                v-model="summary.tenant"
                v-if="is_winedirect_big_commerce"
                autocomplete="off"
            />

            <v-text-field
                label="Bottle360 System Username"
                hint="Enter the dedicated Bottle360 system user's username. This account should not be used for regular user logins."
                v-model="summary.username"
                v-if="is_bottle360"
                autocomplete="off"
            />
            <v-text-field
                label="Bottle360 System Password"
                hint="Enter the dedicated Bottle360 system user's password. This account should not be used for regular user logins."
                v-model="new_password"
                v-if="is_bottle360"
                autocomplete="off"
                type="password"
            />
            <v-text-field
                label="Tenant Name"
                hint="Your winery name as it appears in your Bottle360 URL (e.g., 'joeswinery' for https://joeswinery.bottlethreesixty.com)"
                v-model="summary.tenant"
                v-if="is_bottle360 && !bottle360_is_demo_account"
                autocomplete="off"
            />

            <v-text-field
                label="API Key (password)"
                v-model="new_password"
                type="password"
                v-if="is_tock_v2"
                autocomplete="off"
            />

            <p
                v-if="is_winedirect"
            >
                <a href="https://documentation.vin65.com/Settings/Admin-Users/Webservice-Accounts#how-to-setup-a-webservice-account" target="_blank">How to create a Wine Direct WebService Account</a>
            </p>

            <v-text-field
                label="Password"
                hint="Your vinSUITE password"
                v-model="new_password"
                type="password"
                v-if="is_vinsuite"
                autocomplete="off"
            />

            <v-text-field
                label="Password"
                hint="Your WineDirect Fulfillment password"
                v-model="new_password"
                type="password"
                v-if="is_wine_direct_fulfillment"
                autocomplete="off"
            />



            <v-text-field
                label="API Key"
                v-model="new_password"
                type="password"
                v-if="is_mailchimp"
                autocomplete="off"
            />

            <v-text-field
                label="Password"
                v-model="new_password"
                type="password"
                v-if="is_vineos"
                autocomplete="off"
            />

            <v-text-field
                label="Password"
                v-model="new_password"
                type="password"
                v-if="is_offset"
                autocomplete="off"
            />

            <v-text-field
                label="Password"
                v-model="new_password"
                type="password"
                v-if="is_winedirect"
                autocomplete="off"
            />

            <v-text-field
                label="Password"
                v-model="new_password"
                type="password"
                v-if="is_ecellar"
                autocomplete="off"
            />

            <v-text-field
                label="Access Token"
                hint="Your All New WineDirect access token"
                v-model="new_password"
                v-if="is_winedirect_big_commerce"
                autocomplete="off"
                type="password"
            />

            <v-text-field
                label="Password"
                hint="The password for the web services account"
                v-model="new_password"
                v-if="is_ship_compliant"
                autocomplete="off"
                type="password"
            />

            <v-switch
                v-if="is_bottle360"
                v-model="bottle360_is_demo_account"
                label="Is Demo Account?"
                hint="Use demo/development URLs for API requests"
            />

            <v-text-field
                label="API Key"
                hint="Your Copper Peak InfoPlus WMS API key"
                v-model="new_password"
                v-if="is_copper_peak"
                autocomplete="off"
                type="password"
            />

            <v-text-field
                label="API Key"
                hint="Your Corksy API key"
                v-model="new_password"
                v-if="is_corksy"
                autocomplete="off"
                type="password"
            />

            <v-text-field
                label="API Key"
                hint="Your Vinoshipper API Key (e.g. 5745.D8A91189BA084968)"
                v-model="summary.username"
                v-if="is_vinoshipper"
                autocomplete="off"
            />

            <v-text-field
                label="Secret"
                hint="Your Vinoshipper Secret"
                v-model="new_password"
                v-if="is_vinoshipper"
                autocomplete="off"
                type="password"
            />

            <v-switch
                v-if="is_commerce7 && $rc.$state.isAuthActorSystemAdmin()"
                v-model="summary.enabled_tag_customers_with_consent"
                label="Tag customers with RedChirp consent tags"
            />


            <v-switch
                v-model="summary.enabled"
                label="Enabled"
            />


            <m-integration-features-dialog
                ref="features-dialog"
            />


        </v-card-text>

        <v-card-actions>
            <v-btn
                text
                v-if="this.$rc.integrationSupports(summary.content_type, 'sync')"
                v-on:click="onSyncNow"
            >
                Resynchronize with {{integration_name}}
            </v-btn>

            <v-spacer></v-spacer>

            <v-btn
                text
                @click="onClickDiscardChanges"
            >
                Cancel
            </v-btn>

            <v-btn
                text
                @click="onClickSave"
                color="primary"
            >
                Ok
            </v-btn>



        </v-card-actions>


    </v-card>

    <!-- Loading overlay for credential validation -->
    <v-overlay
        :value="validating_credentials"
        absolute
        opacity="0.3"
        z-index="1000"
    >
        <div class="text-center">
            <div class="text-h6 mb-4 white--text validation-text">Validating credentials...</div>
            <v-progress-circular
                :size="70"
                color="primary"
                indeterminate
            />
        </div>
    </v-overlay>

    <m-shopify-install-instructions
        ref="shopify-install-instructions"
    />

</v-dialog>
</template>

<script>
const _ = require('lodash');

import MShopifyInstallInstructions from '@/views/integrations/shopify/shopify-install-instructions.vue';
import IntegrationApiDocs from '@/views/integrations/integration-api-docs.vue';

export default {

    components: {
        MShopifyInstallInstructions,
        IntegrationApiDocs
    },

    data() {
        return {
            summary: null,
            dialog: false,
            new_password: null,
            clear_care_tenant_choices: [],
            validating_credentials: false,
        }
    },

    methods: {

        onClickFeatures()
        {
            this.$refs['features-dialog'].showDialog(this.summary.content_type);
        },

        showDialog(summary)
        {
            this.summary = _.cloneDeep(summary);
            this.new_password = 'pw-not-changed';

            this.dialog = true;
            this.$router.dialog_guard = this.dialogGuard;

            if ( summary.tenant != null )
            {
                this.clear_care_tenant_choices = [
                    {'text' : summary.tenant, 'value' : summary.tenant },
                ];
            }
            else
            {
                this.clear_care_tenant_choices = [];
            }

            if ( this.$rc.isAuthActorSystemAdmin() )
            {
                this.$rc.rest(
                    'LIST: /api/v1/integrations/clear-care/agency',

                    {
                    },

                    (data) => {

                        let choices = [];

                        for ( let i = 0; i < data.results.length; i++ )
                        {
                            let cur = data.results[i];

                            choices.push(
                                {
                                    'text' :  cur.subdomain+": "+cur.agency_name+" (clients: "+cur.client_count+", care givers: "+cur.caregiver_count+")",
                                    'value' : cur.subdomain,
                                }
                            )
                        }

                        this.clear_care_tenant_choices = choices;
                    },

                    () => {
                        this.$rc.alert('Error','Unable to list clear care agencies');
                    },
                );
            }
        },

        closeDialog()
        {
            this.dialog = false;
            this.$router.dialog_guard = null;
        },

        dialogGuard(to, from, next)
        {
            if ( this.dialog == false)
            {
                // slipup somehow
                this.$router.dialog_guard = null;
                return;
            }

            this.$router.dialog_guard = null;
            this.dialog = false;
            next(false);
        },

        patch(after_patch)
        {
            this.validating_credentials = true;

            let settings = {
                    'organization_id' : this.summary.organization_id,
                    'settings_id': this.summary.settings_id,
                    'content_type' : this.summary.content_type,
                    'enabled' : this.summary.enabled,
                    'tenant' : this.summary.tenant,
                    'username': this.summary.username,
                    'brand_label': this.summary.brand_label,
                    'integration_label': this.summary.integration_label,
                    'enabled_tag_customers_with_consent': this.summary.enabled_tag_customers_with_consent,
                    'extra_fields': this.summary.extra_fields,
                };

            if ( this.new_password != 'pw-not-changed' )
            {
                settings.password = this.new_password;
            }

            this.$rc.rest({
                'endpoint': 'PATCH: /api/v1/integrations/crm/settings',
                'timeout': '2 min',
                'params': settings,
                'on_success': (data) => {
                    this.validating_credentials = false;

                    if ( !data.credentials_valid && data.enabled )
                    {
                        this.summary.enabled = false;
                        this.$rc.alert('Warning: Invalid Credentials', 'The credentials (tenant, username and/or password) you have provided are not correct.<br/><br/>No data will update until you enter valid credentials.');
                    }

                    if ( after_patch != null )
                    {
                        after_patch();
                        return;
                    }
                },
                'on_error': () => {
                    this.validating_credentials = false;
                    this.$rc.alert('Error','Unable to update settings');
                }
            });
        },

        onClickSave()
        {
            this.patch(() => {
                this.closeDialog();
                this.$emit('ok');
            });
        },

        onClickDiscardChanges()
        {
            this.$router.dialog_guard = null;
            this.closeDialog();
        },


        onSyncNow()
        {
            this.patch(() => {

                this.closeDialog();
                this.$emit('ok');

                this.$rc.showSpinner();

                this.$rc.rest(
                    'PUT: /api/v1/integrations/crm/sync-now',

                    {
                        'organization_id' : this.summary.organization_id,
                        'settings_id': this.summary.settings_id,
                        'content_type' : this.summary.content_type,
                        'sync_type' : 'full',
                    },

                    (data) => {
                        this.$rc.hideSpinner();

                        this.$rc.snackbar('A full synchronization will start momentarily');
                    },

                    () => {
                        this.$rc.hideSpinner();
                        this.$rc.alert('Error','Unable to start full sync.');
                    },
                );
            })
        },

        onAuthorizeShopify()
        {
            this.patch(() => {
                // this.closeDialog();
                // this.$emit('ok');

                this.$rc.rest({
                    'spinner': true,
                    'endpoint': 'PUT: /api/v1/integrations/oauth/start-auth',
                
                    'params': {
                        'integration_type': 'shopify',
                        'employee_id': this.$rc.$state.getEmployeeId(),
                        'query': {
                            'shop': this.summary.tenant
                        },
                    },
                
                    'on_success': (data) => {
                        window.location = data.url;
                    },
                
                    'on_error': 'Unable to start OAuth pairing',
                });
            });
        },

        showShopifyInstructions()
        {
            this.$refs['shopify-install-instructions'].showDialog();
        }

    },

    computed: {
        title() {
            if ( this.summary != null )
             return this.$rc.pretty(this.summary.content_type, 'integration_name')+' Settings';

            return 'Integration Settings';
        },

        is_commerce7()
        {
            if ( this.summary == null )
                return false;

            return this.summary.content_type == 'commerce7';
        },

        is_wineco()
        {
            if ( this.summary == null )
                return false;

            return this.summary.content_type == 'wine-co';
        },

        is_wine_direct_fulfillment()
        {
             if ( this.summary == null )
                return false;

            return this.summary.content_type == 'wine-direct-fulfillment';
        },

        is_mailchimp()
        {
            if ( this.summary == null )
                return false;

            return this.summary.content_type == 'mailchimp';
        },

        is_wine_shipping()
        {
            if ( this.summary == null )
                return false;

            return this.summary.content_type == 'wine-shipping';
        },

        is_tock_v1()
        {
            if ( this.summary == null )
                return false;

            return this.summary.content_type == 'tock';
        },

        is_tock_v2()
        {
            if ( this.summary == null )
                return false;

            return this.summary.content_type == 'tock-v2';
        },

        is_ship_engine()
        {
            if ( this.summary == null )
                return false;

            return this.summary.content_type == 'ship-engine';
        },

        is_vinsuite()
        {
            if ( this.summary == null )
                return false;

            return this.summary.content_type == 'vinsuite';
        },

        is_winedirect()
        {
            if ( this.summary == null )
                return false;

            return this.summary.content_type == 'winedirect';
        },

        is_vineos()
        {
            if ( this.summary == null )
                return false;

            return this.summary.content_type == 'vines-os';
        },

        is_shopify()
        {
            if ( this.summary == null ) 
                return false;

            return this.summary.content_type == 'shopify';
        },

        is_vinoshipper()
        {
            if ( this.summary == null )
                return false;

            return this.summary.content_type == 'vinoshipper';
        },

        is_offset()
        {
            if ( this.summary == null )
                return false;

            return this.summary.content_type == 'offset';
        },

        is_corksy()
        {
            if ( this.summary == null )
                return false;

            return this.summary.content_type == 'corksy';
        },

        is_ecellar()
        {
            if ( this.summary == null )
                return false;

            return this.summary.content_type == 'ecellar';
        },

        is_ship_compliant()
        {
            if ( this.summary == null )
                return false;

            return this.summary.content_type == 'ship-compliant';
        },

        is_clear_care()
        {
            if ( this.summary == null )
                return false;

            return this.summary.content_type == 'clear-care';
        },

        is_order_port()
        {
            if ( this.summary == null )
                return false;

            return this.summary.content_type == 'order-port';
        },

        is_winedirect_big_commerce()
        {
            if ( this.summary == null )
                return false;

            return this.summary.content_type == 'winedirect-big-commerce';
        },

        is_bottle360()
        {
            if ( this.summary == null )
                return false;

            return this.summary.content_type == 'bottle360';
        },

        is_in_beta()
        {
            if ( this.summary == null )
                return false;

            const beta_codes = {
                'vinoshipper': 'beta-integration-vinoshipper',
                'corksy': 'beta-integration-corksy',
            };

            const code = beta_codes[this.summary.content_type];
            if ( !code )
                return false;

            return this.$rc.isValidEnumValue(code, 'beta_features');
        },

        bottle360_is_demo_account: {
            get()
            {
                if ( this.summary == null || !this.is_bottle360 )
                    return false;

                if ( this.summary.extra_fields && this.summary.extra_fields.is_demo_account !== undefined )
                    return this.summary.extra_fields.is_demo_account;

                return false;
            },
            set(value)
            {
                if ( this.summary == null || !this.is_bottle360 )
                    return;

                if ( this.summary.extra_fields == null )
                    this.$set(this.summary, 'extra_fields', {});

                this.$set(this.summary.extra_fields, 'is_demo_account', value);
            }
        },

        is_copper_peak()
        {
            if ( this.summary == null )
                return false;

            return this.summary.content_type == 'copper-peak';
        },

        integration_name()
        {
            return this.$rc.pretty(this.summary.content_type, 'integration_name');
        },

        tock_email()
        {
            return 'tock.'+this.summary.organization_id+'@redchirp-mail.com';
        },
    },
}
</script>

<style lang="scss" scoped>
.validation-text {
    text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.8);
}
</style>